import { MobileExpertDisclosure } from "../mobile/mobilePrimitives.tsx";
import { helpers } from "../util/helpers.ts";
import i18n from "../util/i18n.ts";
import { createMobileReturnUrl } from "../util/mobilePageContext.ts";

// U6-4: season history is the League-domain archive home. Draft history and
// draft lottery belong to the Market domain, so they are secondary archive
// exits rather than sibling tabs. The return seed captures the live history URL
// (root, current season, or past season) for an exact return.
const ARCHIVE_LINKS = [
	{
		key: "draftHistory",
		href: ["draft_history"],
		label: "historyHub.navDraftHistory",
		defaultLabel: "Draft history",
	},
	{
		key: "draftLottery",
		href: ["draft_lottery"],
		label: "historyHub.navDraftLottery",
		defaultLabel: "Draft lottery",
	},
] as const;

const createHistoryArchiveHref = (destUrl: string) =>
	createMobileReturnUrl(destUrl, {
		pageID: "history",
		returnLabel: i18n.t("history.title", {
			ns: "ui",
			defaultValue: "Season Summary",
		}),
		scrollY: typeof window !== "undefined" ? window.scrollY : undefined,
	});

export const HistoryDomainNav = () => (
	<MobileExpertDisclosure
		className="history-domain-nav mt-3"
		expertHostId="history-domain-nav"
		data-history-domain-nav=""
		data-history-domain-archive-disclosure=""
		summary={i18n.t("historyHub.archiveLinksSummary", {
			ns: "ui",
			defaultValue: "Draft archives",
		})}
	>
		<nav
			aria-label={i18n.t("historyHub.archiveLinksSummary", {
				ns: "ui",
				defaultValue: "Draft archives",
			})}
			data-history-domain-links=""
		>
			<div className="d-flex flex-wrap gap-2">
				{ARCHIVE_LINKS.map((view) => (
					<a
						className="btn btn-sm btn-light-bordered"
						data-history-domain-link={view.key}
						href={createHistoryArchiveHref(
							helpers.leagueUrl([...view.href]),
						)}
						key={view.key}
					>
						{i18n.t(view.label, {
							ns: "ui",
							defaultValue: view.defaultLabel,
						})}
					</a>
				))}
			</div>
		</nav>
	</MobileExpertDisclosure>
);

export default HistoryDomainNav;
